<template>
  <!--  订单提货-->
  <div id="myOrderDelivery">
    <div
      style="width: 100%; height: 100%; margin-top: 32px; padding-bottom: 40px"
    >
      <allMallSerch style="border-bottom: 1px solid #e6e6e6"></allMallSerch>
      <div>
        <div style="width: 1300px; margin: auto; padding-top: 20px">
          <div class="deliveBody" v-if="baigangOrderList.length !== 0">
            <nav>提货方式</nav>
            <div class="SinceLiftDiv">
              <div>
                <span>买方自提</span>
                <div>
                  <i class="icon iconfont iconapproved"></i>
                </div>
              </div>
            </div>
            <div class="ztPlaceDiv">
              <p
                @click="showDetailFun(item)"
                :key="index"
                v-for="(item, index) in canChooseWareHouse"
              >
                <span
                  >自提地点：{{ item.provinceName }}{{ item.cityName
                  }}{{ item.areaName }}{{ item.address }}</span
                ><span class="colorRedff0000 f_w">({{ item.name }})</span
                ><i
                  class="icon iconfont icondingwei1 colorBlue0289fb m_l_10"
                ></i>
              </p>
            </div>
            <div>
              <div v-if="baigangOrderList.length > 0">
                <nav class="font18 m_l_20 f_w m_b_10">商品列表</nav>
                <div style="margin: 0 20px">
                  <table class="delTable">
                    <thead>
                      <tr>
                        <th>
                          <input
                            class="allCheckbox"
                            id="allchecked"
                            v-model="shopCheckedAll"
                            type="checkbox"
                            @change="checkedAll"
                          />
                          <label for="allchecked"></label>
                        </th>
                        <!--                    <th>-->
                        <!--                      <input type="checkbox" class="allCheckbox" id="fatherCheck">-->
                        <!--                      <label for="fatherCheck"></label>-->
                        <!--                    </th>-->
                        <th>商品信息</th>
                        <th>仓库</th>
                        <th>计量方式</th>
                        <th>数量(支)</th>
                        <th>重量(吨)</th>
                        <th
                        >单价(元)</th>
                        <th
                        >吊费(元)</th>
                        <th>货款金额(元)</th>
                        <th>总价(元)</th>
                        <th>操作</th>
                      </tr>
                      <tr class="OccupiTr" style="height: 20px">
                        <th colspan="12"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        :key="index"
                        v-for="(item, index) in baigangOrderList"
                      >
                        <!--                    <td>-->
                        <!--                      <input type="checkbox" class="allCheckbox" id="childCheck">-->
                        <!--                      <label for="childCheck"></label>-->
                        <!--                    </td>-->
                        <td>
                          <input
                            v-if="item.status === '1'"
                            class="allCheckbox"
                            :id="'lijiList' + index"
                            v-model="item.checked"
                            type="checkbox"
                            @change="shopIsZeroClear(baigangOrderList);reflashOrder();"
                          />
                          <span v-else style="color: red">已下架</span>
                          <label :for="'lijiList' + index"></label>
                        </td>
                        <td :class="item.status === '2' ? 'seldOut' : ''">
                          <p>{{ item.name }}</p>
                          <p>
                            {{ item.shopGoodVO.materialQualityName || "-" }}
                            {{ item.shopGoodVO.guige || "-" }}
                            {{ item.shopGoodVO.originPlaceName || "-" }}
                          </p>
                        </td>
                        <td :class="item.status === '2' ? 'seldOut' : ''">{{ item.shopGoodVO.warehouseName }}</td>
                        <td :class="item.status === '2' ? 'seldOut' : ''">
                          <p
                            v-if="
                              item.shopGoodVO.settlementType === '1' ||
                              item.shopGoodVO.settlementType === '3'
                            "
                            class="m_b_10"
                          >
                            <input
                              @change="reflashOrder"
                              type="radio"
                              class="allRadio"
                              :id="'chlidRadio' + index"
                              v-model="item.settlementType"
                              :value="'1'"
                              :name="'childRadioName' + index"
                            />
                            <label :for="'chlidRadio' + index"></label>
                            <label :for="'chlidRadio' + index"
                              ><span>理计</span></label
                            >
                          </p>
                          <p
                            v-if="
                              item.shopGoodVO.settlementType === '2' ||
                              item.shopGoodVO.settlementType === '3'
                            "
                          >
                            <input
                              @change="reflashOrder"
                              type="radio"
                              class="allRadio"
                              :id="'chlidRadioBangji' + index"
                              v-model="item.settlementType"
                              :value="'2'"
                              :name="'childRadioName' + index"
                            />
                            <label :for="'chlidRadioBangji' + index"></label>
                            <label :for="'chlidRadioBangji' + index"
                              ><span>磅计</span></label
                            >
                          </p>
                        </td>
                        <td :class="item.status === '2' ? 'seldOut' : ''">
                          <!-- {{item.amount}} -->
                          <div class="CalculateDiv" style="height: 26px">
                            <!--                          <abbr>{{item.amount}}</abbr>-->
                            <span
                              @click="changeAmount('sub', item)"
                              style="
                                line-height: 24px;
                                font-size: 22px;
                                width: 26px;
                              "
                              :class="item.amount <= 1 ? 'reduce-nerver' : ''"
                              >-
                              </span
                            >
                            <div style="width: 50px">
                              <input
                                readonly
                                v-model="item.amount"
                                type="number"
                              />
                            </div>
                            <span
                              @click="changeAmount('add', item)"
                              style="
                                line-height: 20px;
                                font-size: 20px;
                                width: 26px;
                              "
                              >+</span
                            >
                          </div>
                        </td>
                        <td :class="item.status === '2' ? 'seldOut' : ''">
                          <p>
                            {{
                                item.settlementType === "1"
                                ? parseFloat(
                                    item.shopGoodVO.lisuanWeight * item.amount
                                  ).toFixed(2)
                                : parseFloat(
                                    item.shopGoodVO.weight * item.amount
                                  ).toFixed(2)
                            }}
                          </p>
                        </td>
                        <td :class="item.status === '2' ? 'seldOut' : ''">
                          <!--                      <p class="m_b_5 rulSpan colorGray959595">3720</p>-->
                          <p class="">
                            {{
                              baigangToken ? parseFloat(
                                item.settlementType === "1"
                                  ? item.shopGoodVO.lisuanPrice
                                  : item.shopGoodVO.price
                              ).toFixed(2) : '**'
                            }}
                          </p>
                          <!--                      <p class="varySpan varySpan_reddc0000 font12">涨价10元</p>-->
                        </td>
                        <!-- 磅计 2, 理计 1 -->
                        <td class="f_w" :class="item.status === '2' ? 'seldOut' : ''">
                          <p class="" v-if="item.settlementType === '1'">
                            {{
                              baigangToken ? item.settlementType === "1"
                                ? parseFloat(
                                    item.shopGoodVO.hoistingFee *
                                      item.shopGoodVO.lisuanWeight *
                                      item.amount
                                  ).toFixed(2)
                                : 0 : '**'
                            }}
                          </p>
                          <p class="" v-if="item.settlementType === '2'">
                            {{
                              baigangToken ? item.settlementType === "2"
                                ? parseFloat(
                                    item.shopGoodVO.hoistingFee *
                                      item.shopGoodVO.weight *
                                      item.amount
                                  ).toFixed(2)
                                : 0 : '**'
                            }}
                          </p>
                        </td>
                        <td class="f_w" :class="item.status === '2' ? 'seldOut' : ''">
                          <p v-if="item.settlementType === '1'" class="">
                            {{
                              baigangToken ? parseFloat(
                                item.amount *
                                  item.shopGoodVO.lisuanPrice *
                                  item.shopGoodVO.lisuanWeight
                              ).toFixed(2) : '**'
                            }}
                          </p>
                          <p v-if="item.settlementType === '2'" class="">
                            {{
                              baigangToken ? parseFloat(
                                item.amount *
                                  item.shopGoodVO.price *
                                  item.shopGoodVO.weight
                              ).toFixed(2) : '**'
                            }}
                          </p>
                        </td>
                        <td class="f_w colorRed" :class="item.status === '2' ? 'seldOut' : ''">
                          <p v-if="item.settlementType === '1'" class="">
                            {{
                              baigangToken ? parseFloat(
                                item.amount *
                                  item.shopGoodVO.lisuanPrice *
                                  item.shopGoodVO.lisuanWeight +
                                  item.diaochefei *
                                    item.shopGoodVO.lisuanWeight *
                                    item.amount
                              ).toFixed(2) : '**'
                            }}
                          </p>
                          <p v-if="item.settlementType === '2'" class="">
                            {{
                              baigangToken ?
                              parseFloat(
                                item.amount *
                                  item.shopGoodVO.price *
                                  item.shopGoodVO.weight +
                                  item.diaochefei *
                                    item.shopGoodVO.weight *
                                    item.amount
                              ).toFixed(2)
                              :
                              '**'
                            }}
                          </p>
                        </td>
                        <td>
                          <p
                            @click="deleteItem(item, index)"
                            class="colorBlue0289fb c_p"
                          >
                            删除
                          </p>
                          <!-- <p class="varySpan varySpan_reddc0000 c_p">生成合同</p>-->
                        </td>
                      </tr>
                      <!--                  <tr>-->
                      <!--                    <td>-->
                      <!--                      <input type="checkbox" class="allCheckbox" id="childCheck">-->
                      <!--                      <label for="childCheck"></label>-->
                      <!--                    </td>-->
                      <!--                    <td>-->
                      <!--                      <p>H型钢</p>-->
                      <!--                      <p>Q235B 125*1256.5*9 12.0米 东方特钢</p>-->
                      <!--                    </td>-->
                      <!--                    <td>1号门</td>-->
                      <!--                    <td>-->
                      <!--                      <p></p>-->
                      <!--                      <p></p>-->
                      <!--                    </td>-->
                      <!--                    <td>-->
                      <!--                      <div class="CalculateDiv" style="height: 26px">-->
                      <!--                        <span style="line-height: 24px;font-size: 22px;width: 26px">-</span>-->
                      <!--                        <div style="width: 50px">-->
                      <!--                          <input type="number"/>-->
                      <!--                        </div>-->
                      <!--                        <span style="line-height: 20px;font-size: 20px;width: 26px">+</span>-->
                      <!--                      </div>-->
                      <!--                    </td>-->
                      <!--                    <td>0.286</td>-->
                      <!--                    <td>-->
                      <!--                      <p class="m_b_5 rulSpan colorGray959595">3720</p>-->
                      <!--                      <p class="m_b_5 f_w">3730</p>-->
                      <!--                      <p class="varySpan varySpan_Green32b16c font12">降价10元</p>-->
                      <!--                    </td>-->
                      <!--                    <td class="f_w">7.15</td>-->
                      <!--                    <td>1066.78</td>-->
                      <!--                    <td>1073.93</td>-->
                      <!--                    <td class="p_r t_r" style="overflow: hidden">-->
                      <!--                      <p class="colorBlue0289fb m_b_5 c_p">删除</p>-->
                      <!--                      <p class="varySpan varySpan_reddc0000 c_p">生成合同</p>-->
                      <!--                    </td>-->
                      <!--                  </tr>-->
                      <!--                  <tr style="background-color: #dcdcdc">-->
                      <!--                    <td>-->
                      <!--                      <input type="checkbox" class="allCheckbox" id="childCheck">-->
                      <!--                      <label for="childCheck"></label>-->
                      <!--                    </td>-->
                      <!--                    <td>-->
                      <!--                      <p>H型钢</p>-->
                      <!--                      <p>Q235B 125*1256.5*9 12.0米 东方特钢</p>-->
                      <!--                    </td>-->
                      <!--                    <td>1号门</td>-->
                      <!--                    <td>-->
                      <!--                      <p></p>-->
                      <!--                      <p></p>-->
                      <!--                    </td>-->
                      <!--                    <td>-->
                      <!--                      <div class="CalculateDiv" style="height: 26px">-->
                      <!--                        <span style="line-height: 24px;font-size: 22px;width: 26px">-</span>-->
                      <!--                        <div style="width: 50px">-->
                      <!--                          <input type="number"/>-->
                      <!--                        </div>-->
                      <!--                        <span style="line-height: 20px;font-size: 20px;width: 26px">+</span>-->
                      <!--                      </div>-->
                      <!--                    </td>-->
                      <!--                    <td>0.286</td>-->
                      <!--                    <td>-->
                      <!--                      <p class="m_b_5 rulSpan colorGray959595">3720</p>-->
                      <!--                      <p class="m_b_5 f_w">3730</p>-->
                      <!--                      <p class="varySpan varySpan_Green32b16c font12">降价10元</p>-->
                      <!--                    </td>-->
                      <!--                    <td class="f_w">7.15</td>-->
                      <!--                    <td>1066.78</td>-->
                      <!--                    <td>1073.93</td>-->
                      <!--                    <td class="p_r" style="overflow: hidden">-->
                      <!--                      <i class="icon iconfont iconclose" style="font-size: 12px"></i>-->
                      <!--                      <div class="soldDiv">-->
                      <!--                        <p>售空</p>-->
                      <!--                      </div>-->
                      <!--                    </td>-->
                      <!--                  </tr>-->
                    </tbody>
                  </table>
                </div>
                <div
                style="padding: 20px"
                class="couponDiv"
                :class="jinyongyouhui ? 'never' : ''">
                  <!--                <nav>-->
                  <!--                  <span class="onCouSpan">满减</span>-->
                  <!--                  <span>打折</span>-->
                  <!--                </nav>-->
                  <dl>
                    <!-- {{ (selectCouponIndex || selectCouponIndex == 0) && couponList[selectCouponIndex].couponValue}} -->
                    <dd
                      v-if="(selectCouponIndex !== -1) ? (allTotalPrice + couponList[selectCouponIndex].couponValue) >= coupItem.threshold : allTotalPrice >= coupItem.threshold"
                      @click="selectCoupon(coupItem, coupIndex)"
                      :key="coupIndex"
                      v-for="(coupItem, coupIndex) in couponList"
                    >
                      <div
                        :class="
                          selectCouponIndex === coupIndex
                            ? 'b_c_rede1251b'
                            : 'noActive'
                        "
                        class="colorWhite"
                      >
                        <p class="d_flex m_b_10">
                          <span
                            class="font16"
                            v-if="parseInt(coupItem.type) === 2"
                          >
                            <span class="font22"
                              >{{ coupItem.couponValue }}元</span
                            >
                            <span class="font12"
                              >满{{ coupItem.threshold }}</span
                            >
                          </span>
                          <span
                            class="font16"
                            v-if="parseInt(coupItem.type) === 3"
                          >
                            <span class="font22"
                              >{{ coupItem.couponValue }}折</span
                            >
                            <span class="font12"
                              >满{{ coupItem.threshold }}</span
                            >
                          </span>
                          <span>x {{ coupItem.surplusNum }}张</span>
                        </p>
                        <p>
                          有效期至{{
                            $commonJs.returnNewDate(coupItem.endTime, "YYMMDD")
                          }}
                        </p>
                      </div>
                      <div class="p_r" style="overflow: hidden">
                        <span
                          class="colorGray959595"
                          v-if="parseInt(coupItem.goodScope) === 1"
                          >[全商品]</span
                        >
                        <span
                          class="colorGray959595"
                          v-if="parseInt(coupItem.goodScope) === 2"
                          >[部分商品]</span
                        >
                        <span
                          class="colorGray959595"
                          v-if="parseInt(coupItem.type) === 2"
                          >[满减券]</span
                        >
                        <span
                          class="colorGray959595"
                          v-if="parseInt(coupItem.type) === 3"
                          >[打折券]</span
                        >
                        <div
                          v-if="selectCouponIndex === coupIndex"
                          class="onCouSel"
                        >
                          <i class="icon iconfont iconapproved"></i>
                        </div>
                      </div>
                      <!--                    <section class="font12">-->
                      <!--                      <i class="icon iconfont icontishi" style="font-size: 12px"></i>-->
                      <!--                      <span class="colorGray959595 m_l_5">所结算商品中没有符合条件的商品</span>-->
                      <!--                    </section>-->
                    </dd>
                  </dl>
                </div>
                <div style="padding: 20px">
                  <ul>
                    <li class="d_flex m_b_5">
                      <div>
                        <!--                      <input type="checkbox" class="allCheckbox" id="lastCheck">-->
                        <!--                      <label for="lastCheck"></label>-->
                        <!--                      <label for="lastCheck"><span class="m_l_5 c_p">全选</span></label>-->
                        <!--                      <span class="c_p">删除选中商品</span>-->
                        <!--                      <span class="colorReded222c c_p">清空</span>-->
                      </div>
                      <div>
                        <span>商品小计：已选</span>
                        <span class="colorReded222c f_w">{{
                          lijitotalCount.number + bangjitotalCount.number
                        }}</span>
                        <span>支，共</span>
                        <span class="colorReded222c f_w">{{
                          parseFloat(
                            bangjitotalCount.weight +
                              lijitotalCount.lisuanWeight
                          ).toFixed(2)
                        }}</span>
                        <span>吨</span>
                      </div>
                    </li>
                    <li class="d_flex m_b_5">
                      <span></span>
                      <div>
                        <span>货款：</span>
                        <span class="colorReded222c f_w">{{
                          baigangToken ? parseFloat(
                            bangjitotalCount.price + lijitotalCount.lisuanPrice
                          ).toFixed(2) : '**'
                        }}</span>
                        <span>元</span>
                      </div>
                    </li>
                    <li class="d_flex m_b_5">
                      <span></span>
                      <div>
                        <span>+吊费</span>
                        <i class="icon iconfont iconjinggao"></i>
                        <span>：</span>
                        <span class="colorReded222c f_w">{{
                          baigangToken ? parseFloat(
                            lijitotalCount.lisuanDiaochefei +
                              bangjitotalCount.bangjidiaochefei
                          ).toFixed(2) : '**'
                        }}</span>
                        <span>元</span>
                      </div>
                    </li>
                    <li class="d_flex m_b_5">
                      <span></span>
                      <div>
                        <!-- <span>合计（不含运费）：</span>
                        <span
                          class="colorReded222c font20 f_w"
                          style="vertical-align: bottom"
                          >￥
                          {{
                            parseFloat(
                              bangjitotalCount.bangjiAllTotalPrice +
                                lijitotalCount.lisuanAllTotalPrice
                            ).toFixed(2)
                          }}</span
                        > -->
                        <span
                          class="colorReded222c font20 f_w"
                          style="vertical-align: bottom"
                          >优惠金额：￥ {{ baigangToken ? (
                            couponList[selectCouponIndex] && couponList[selectCouponIndex].type === '2' ? couponList[selectCouponIndex].couponValue || '0' : (( couponList[selectCouponIndex] && couponList[selectCouponIndex].couponValue * 0.1 ) * lijitotalCount.lisuanAllTotalPrice) || 0 .toFixed(2) || ''
                          ) : '**' }}</span
                        >
                        <span
                          class="colorReded222c font20 f_w"
                          style="vertical-align: bottom"
                          >￥ {{ baigangToken ? allTotalPrice.toFixed(2) : '**' }}</span
                        >
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- <div style="padding: 20px">
                  <textarea
                    v-model="lisuanLeaveMessage"
                    placeholder="请输入备注"
                    @input="() => {
                      if (lisuanLeaveMessage.length > 200) lisuanLeaveMessage = lisuanLeaveMessage.substring(0, 200)
                    }"
                    class="allTextarea2"
                    name=""
                    cols="30"
                    rows="10"
                    style="padding-bottom: 30px;"
                  ></textarea>
                  <p
                  style="margin-top: -25px;margin-right: 12px;text-align: right;">
                    {{lisuanLeaveMessage.length}}
                    /200
                  </p>
                </div> -->
                <div class="delLatBt">
                  <span @click="$router.push('/')">返回商城</span>
                  <span @click="loadbishi(() => orderConfirm('lisuan'))">生成订单</span>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="baigangOrderList.length === 0"
            class="t_c b_b h_100"
            style="width: 100% !important"
          >
            <div class="t_c">
              <img
                src="../../../../assets/blank.png"
                style="width: 200px"
                alt=""
              />
              <div class="c_d9d9 ft_14">购物车空空如也~</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="showDetail2">
      <div style="opacity: 0.5" class="cover"></div>
      <div
        style="
          text-align: center;
          position: fixed;
          top: calc((100% - 670px) / 2.6);
          background-color: #fff;
          left: calc(50% - 350px);
          width: 700px;
          z-index: 1001;
        "
      >
        <div style="width: 100%; height: 600px" id="container"></div>
        <button
          @click="showDetail2 = false"
          style="margin: 20px; bottom: 0; right: 0"
          class="cancelButton p_a"
        >
          返回
        </button>
      </div>
    </div>
    <model
      v-if="showModel"
      :onButton="'2'"
      :title="'选择支付方式'"
      :minWidth="'500px'"
      v-on:on-cancel="showModel = false"
      v-on:on-confirm="confirmAd()"
    >
      <div class="t_c">
        <div style="width: 300px" class="d_inline_flex d_flex p_30">
          <div>
            <p class="p_t_b_5">
              <label for="payWay1"
                ><img
                  src="../../../../assets/zhifubao.png"
                  height="120"
                  width="120"
              /></label>
            </p>
            <p class="t_c font18">
              <input
                v-model="payWay"
                value="aliPay"
                id="payWay1"
                class="allRadio"
                type="radio"
                name="payWay"
              />
              <label for="payWay1"></label>
              <label for="payWay1">支付宝</label>
            </p>
          </div>
          <div style="margin-left: 20%">
            <p class="p_t_b_5">
              <label for="payWay2"
                ><img
                  src="../../../../assets/weixin.png"
                  height="120"
                  width="120"
              /></label>
            </p>
            <p class="t_c font18">
              <input
                v-model="payWay"
                value="wechatPay"
                id="payWay2"
                class="allRadio"
                type="radio"
                name="payWay"
              />
              <label for="payWay2"></label>
              <label for="payWay2">微信</label>
            </p>
          </div>
        </div>
      </div>
    </model>

    <model
      v-if="showModel1"
      :onButton="'1'"
      :title="'上传凭证'"
      :minWidth="'500px'"
      v-on:on-cancel="showModel1 = false"
      v-on:on-confirm="allSure1()"
    >
      <div class="p_d4B">
        <div>
          <ul class="ShowModelUl">
            <li>
              <span class="">上传支付凭证：</span>
              <div class="dis_line v_m">
                <input
                  @change="changeFlieName($event)"
                  type="file"
                  id="bannerFile"
                  class="allImgFile"
                  accept="image/*"
                  required
                />
                <label for="bannerFile" style="margin-left: 18px"
                  >选择资源</label
                >
                <div
                  class="dis_line v_m"
                  style="width: 25%"
                  v-if="orderPostData.detailList[0].voucherUrl"
                >
                  <img
                    :src="orderPostData.detailList[0].voucherUrl"
                    style="width: 100%"
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </model>
    <model
      v-if="showModel2"
      :onButton="'3'"
      :title="'提示'"
      :minWidth="'500px'"
      v-on:on-cancel="showModel2 = false"
      v-on:on-confirm="continueToOrder()"
    >
      <div class="p_d4B">
        <div>
          <ul class="ShowModelUl">
            <li>低于300公斤物资，按照理计销售</li>
          </ul>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
import Index from '../../myIndex/index'
import pubilshSet from '../../../../assets/js/pubilshSet'
let marker
let map
export default {
  name: 'myOrderDelivery',
  data () {
    return {
      shopCheckedAll: true,
      showModel1: false,
      showModel2: false,
      jinyongyouhui: false,
      orderNum: '',
      totalMoney: 0,
      selectCouponIndex: -1,
      payWay: 'aliPay',
      showDetail2: false,
      showModel: false,
      canChooseWareHouse: [],
      couponList: [],
      WarehouseList: [],
      baigangOrderList: JSON.parse(window.localStorage.getItem('baigangOrderList') || '[]'),
      lijiList: [],
      bangjiList: [],
      lisuanLeaveMessage: '',
      bangjiLeaveMessage: '',
      orderPostData: {},
      orderType: '',
      isBishiTime: false,
      userInfo: JSON.parse(localStorage.getItem('MemberInfo')),
      baigangToken: localStorage.getItem('baigangToken')
    }
  },
  created () {
    document.title = '百钢商城 | 钢铁电商，百炼成钢'
    this.getCouponList()
    this.$axiox.post('/baigang/app/good/queryWarehouseList', { currPage: 1, pageSize: 9999 }).then(p => {
      this.WarehouseList = p.data.list
      this.canChooseWareHouse = []
      this.lijiList = []
      this.bangjiList = []
      for (let i = 0; i < this.baigangOrderList.length; i++) {
        this.$set(this.baigangOrderList[i], 'chooseMethod', this.baigangOrderList[i].shopGoodVO.calculateMethod === '磅计' ? 2 : 1)
        let wareData = this.WarehouseList.find(p => {
          return p.id === this.baigangOrderList[i].shopGoodVO.warehouseId
        })
        if (wareData) {
          this.canChooseWareHouse.push(wareData)
        }
        this.$set(this.baigangOrderList[i], 'diaochefei', (wareData && wareData.hoistingFee) || 0)
      }
      for (let i = 0; i < this.baigangOrderList.length; i++) {
        if (this.baigangOrderList[i].shopGoodVO.settlementType === '3' || this.baigangOrderList[i].shopGoodVO.settlementType === '1') {
          this.lijiList.push(JSON.parse(JSON.stringify(this.baigangOrderList[i])))
        }
        if (this.baigangOrderList[i].shopGoodVO.settlementType === '3' || this.baigangOrderList[i].shopGoodVO.settlementType === '2') {
          this.bangjiList.push(JSON.parse(JSON.stringify(this.baigangOrderList[i])))
        }
      }
      for (let i = 0; i < this.canChooseWareHouse.length; i++) {
        for (let j = i + 1; j < this.canChooseWareHouse.length; j++) {
          if (this.canChooseWareHouse[i].id === this.canChooseWareHouse[j].id) {
            this.canChooseWareHouse.splice(j, 1)
            j--
          }
        }
      }
    }, error => {
      console.log(error)
    })

    this.$commonJs.asyncReturnIsBishiTime().then(
      res => {
        this.isBishiTime = res
      }
    )
  },
  mounted () {
    // 监听storage
    // window.addEventListener('storage', (e) => {
    //   if (e.newValue) {
    //     if (e.key === 'baigangOrderList') {
    //       this.baigangOrderList = JSON.parse(window.localStorage.getItem('baigangOrderList') || '[]')
    //       // this.$forceUpdate()
    //       for (let i = 0; i < this.baigangOrderList.length; i++) {
    //         this.$set(this.baigangOrderList[i], 'chooseMethod', this.baigangOrderList[i].shopGoodVO.calculateMethod === '磅计' ? 2 : 1)
    //         let wareData = this.WarehouseList.find(p => {
    //           return p.id === this.baigangOrderList[i].shopGoodVO.warehouseId
    //         })
    //         if (wareData) {
    //           this.canChooseWareHouse.push(wareData)
    //         }
    //         console.log('1212')
    //         console.log(wareData)
    //         this.$set(this.baigangOrderList[i], 'diaochefei', (wareData && wareData.hoistingFee) || 0)
    //       }
    //       for (let i = 0; i < this.baigangOrderList.length; i++) {
    //         if (this.baigangOrderList[i].shopGoodVO.settlementType === '3' || this.baigangOrderList[i].shopGoodVO.settlementType === '1') {
    //           this.lijiList.push(JSON.parse(JSON.stringify(this.baigangOrderList[i])))
    //         }
    //         if (this.baigangOrderList[i].shopGoodVO.settlementType === '3' || this.baigangOrderList[i].shopGoodVO.settlementType === '2') {
    //           this.bangjiList.push(JSON.parse(JSON.stringify(this.baigangOrderList[i])))
    //         }
    //       }
    //       for (let i = 0; i < this.canChooseWareHouse.length; i++) {
    //         for (let j = i + 1; j < this.canChooseWareHouse.length; j++) {
    //           if (this.canChooseWareHouse[i].id === this.canChooseWareHouse[j].id) {
    //             this.canChooseWareHouse.splice(j, 1)
    //             j--
    //           }
    //         }
    //       }
    //     }
    //   }
    // })
    setTimeout(() => {
      this.reflashOrder()
    }, 600)
  },
  methods: {
    loadbishi (callBack) {
      this.$commonJs.asyncReturnIsBishiTime().then(
        res => {
          this.isBishiTime = res
          callBack()
        }
      )
    },
    checkedAll (e) {
      this.baigangOrderList.forEach((item) => {
        item.checked = e.target.checked
      })
    },
    continueToOrder () {
      // 选中的商品
      const selected = this.baigangOrderList.filter(function (currVal, currIndex, arr) {
        return currVal.checked
      })
      // 计量方式为磅计的商品
      const poundItems = selected.filter(function (currVal, currIndex, arr) {
        return currVal.settlementType === '2'
      })
      // 小于300公斤的磅计商品
      const poundItemsLessThen300 = poundItems.filter(function (currVal, currIndex, arr) {
        return currVal.shopGoodVO.weight < 300
      })
      // 小于300公斤的磅计商品id
      const poundItemsLessThen300Ids = poundItemsLessThen300.map(function (currVal, currIndex, arr) {
        return currVal.id
      })
      // console.log(poundItemsLessThen300Ids, 'poundItemsLessThen300Ids')
      this.baigangOrderList.map(function (currVal, currIndex, arr) {
        if (poundItemsLessThen300Ids.indexOf(currVal.id) > -1) {
          currVal.settlementType = '1'
        }
      })
      this.showModel2 = false
      this.allSure1()
    },
    async allSure1 () {
      // if (!this.orderPostData.detailList[0].voucherUrl) {
      //   this.$commonJs.alertTips({
      //     type: 'error',
      //     title: '请上传凭证',
      //     content: '请上传凭证',
      //     stayTime: 5
      //   })
      //   return false
      // }
      // this.$axiox.post('/baigang/shop/app/order/shopAddOrder/' + (this.orderType === 'lisuan' ? 1 : 2), this.orderPostData).then(p => {
      let data = {
        cartIds: [],
        deliveryId: 0,
        detailList: [
          {
            accountId: 1,
            accountTotalAmt: parseFloat(this.allTotalPrice.toFixed(2)),
            accountTotalScore: 0,
            appOrderGoodParamList: [
            ],
            couponId: (this.couponList[this.selectCouponIndex] && this.couponList[this.selectCouponIndex].couponId) || 0,
            deliveryMethod: '1',
            hasFullAmountGood: '0',
            liveMessage: this.lisuanLeaveMessage,
            noExpressFeeMap: {}
          }
        ]
      }
      let goodList = this.baigangOrderList
      for (let i = 0; i < goodList.length; i++) {
        if (goodList[i].shopCarId && goodList[i].checked && goodList[i].status === '1') {
          data.cartIds.push(goodList[i].shopCarId)
        } let goodData = {
          goodId: goodList[i].goodId || goodList[i].id,
          number: goodList[i].amount,
          settlementType: goodList[i].settlementType,
          skuId: goodList[i].skuId
        }
        if (goodList[i].checked && goodList[i].status === '1') {
          data.detailList[0].appOrderGoodParamList.push(goodData)
        }
      }
      this.orderPostData = data
      if (!this.orderPostData.detailList[0].voucherUrl) {
        this.orderPostData.detailList[0].voucherUrl = ''
      }
      let memberInfo = await this.$axiox.asyncGet('/baigang/sys/user/getCurrUserInfo')
      window.localStorage.setItem('MemberInfo', JSON.stringify(memberInfo))

      this.$axiox.post('/baigang/shop/app/order/shopAddOrder/' + 1, data).then(p => {
        if (p.data) {
          this.orderNum = p.data
          this.showModel1 = false
          // this.showModel = true
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功:',
            content: '下单成功',
            stayTime: 5
          })

          setTimeout(that => {
            window.open(pubilshSet.userCenterHostUrl + 'orderDetails/' + that.orderNum)
          }, 1500, this)
        }
      })
      console.log(this.orderPostData)
    },
    async changeFlieName (e) {
      let file = e.target.files[0]
      let value = e.target.value

      if (file && value) {
        const fileSize = file.size
        const isLt5M = fileSize / 1024 / 1024 < 5
        console.log(fileSize)
        console.log(isLt5M)
        // 小于 5Mb
        if (!isLt5M) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '超过5M',
            content: '上传文件大小不超过5MB',
            stayTime: 5
          })
          file = ''
          value = ''
          return false
        }
        const name = file.name
        const fileType = name.split('.')[1].toLowerCase()
        // 检查文件类型
        if (this.$commonJs.imgUpLoadFileList.indexOf(fileType) < 0) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '类型错误',
            content: '请选择格式文件(jpg、jpeg、png、gif、bmp)上传！',
            stayTime: 5
          })
          file = ''
          value = ''
          return false
        }
        // 上传
        let fileId = await this.$commonJs.uploadFileNew(file)
        this.orderPostData.detailList[0].voucherUrl = fileId.url
        e.target.value = ''
        this.$forceUpdate()
      }
    },
    deleteItem (item, index) {
      // this.baigangOrderList.splice(index, 1)
      this.$commonJs.doubleComfirm({
        content: '是否移除该商品？',
        successFun: msg => {
          this.$axiox.del('/baigang/app/good/removeCartGood/' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '移除成功',
              stayTime: 5
            })
            this.baigangOrderList.splice(index, 1)

            let tempArr = JSON.parse(window.localStorage.getItem('baigangOrderList') || '[]')
            if (tempArr[index]) {
              tempArr.splice(index, 1)
            }
            localStorage.setItem('baigangOrderList', JSON.stringify(tempArr))
          })
        },
        errorFun: msg => {
        }
      })
    },
    reflashOrder () {
      let isAll = 0
      // 如果有商品取消选中那就不全选
      for (const item of this.baigangOrderList) {
        if (item.checked) isAll++
      }
      this.shopCheckedAll = isAll === this.baigangOrderList.length
      // 只要订单内有一个商品是磅计就取消优惠券
      const checkedShop = this.baigangOrderList.filter(item => item.checked)
      let totalAmount = 0
      for (const item of checkedShop) {
        if (item.settlementType === '2') {
          this.selectCouponIndex = -1
          this.jinyongyouhui = true
          // totalAmount += item.price * item.weight * item.number
          return
        }
        if (item.settlementType === '1') {
          // console.log(item, 'itemitemitem');
          totalAmount += parseFloat(item.shopGoodVO.lisuanPrice) * parseFloat(item.shopGoodVO.lisuanWeight) * parseFloat(item.amount)
          totalAmount += parseFloat(item.shopGoodVO.hoistingFee) * parseFloat(item.shopGoodVO.lisuanWeight) * parseFloat(item.amount)
        }
      }
      this.jinyongyouhui = false
      // 选中商品总金额,小于优惠券的额度,就取消优惠券的选中
      // console.log(this.couponList[this.selectCouponIndex], 'totalAmount');
      if ((this.selectCouponIndex !== -1) && (totalAmount < this.couponList[this.selectCouponIndex].threshold)) {
        this.selectCouponIndex = -1
      }
    },
    selectCoupon (item, index) {
      if (this.selectCouponIndex === index) {
        this.selectCouponIndex = -1
      } else {
        this.selectCouponIndex = index
      }
    },
    async getCouponList () {
      let res = await this.$axiox.asyncGet('/baigang/buyer/center/queryMemberCouponList/')
      this.couponList = res
    },
    confirmAd () {
      this.$router.push({
        name: 'orderPayConfirm',
        query: {
          payWay: this.payWay,
          orderNum: this.orderNum,
          totalMoney: this.totalMoney
        }
      })
    },
    async orderConfirm (type) {
      if (parseInt(this.userInfo.account.companyAuth) !== 2) {
        // 如果是个人用户,就跳转到认证页面
        window.open(pubilshSet.userCenterHostUrl + 'companyBasicInfo')
        return
      }
      // 闭市时间不能下单
      if (this.isBishiTime) {
        this.$commonJs.alertTips({
          type: 'error',
          title: 'error',
          content: '现在是闭市时间,营业时间外不能下单',
          stayTime: 5
        })
        return false
      }
      // 选中的商品
      const selected = this.baigangOrderList.filter(function (currVal, currIndex, arr) {
        if (parseInt(currVal.status) !== 1) {
          // 下架的不进行选中,直接false
          return false
        }
        return currVal.checked
      })
      if (selected.length <= 0) {
        this.$commonJs.alertTips({
          type: 'error',
          title: 'error',
          content: '请选择商品',
          stayTime: 5
        })
        return
      }
      // console.log(selected, 'selected');
      const shopCangku = Array.from(
        new Set(selected.map(item => item.shopGoodVO.warehouseName))
      )
      console.log(shopCangku, '商品仓库种类')
      if (shopCangku.length > 1) {
        this.$commonJs.alertTips({
          type: 'error',
          title: 'error',
          content: '仓库不能为两个不同仓库，请重新下单',
          stayTime: 5
        })
        return
      }
      // 订单内存在不同仓库的商品，抛出错误
      // 以下代码房费性能,且偶尔有错误
      // const isDiffWarehouse = !selected.every(function (currVal, currIndex, arr) {
      //   if (currIndex === 0) {
      //     return true
      //   }
      //   return currVal.shopGoodVO.warehouseName === arr[currIndex - 1].shopGoodVO.warehouseName
      // }, this.baigangOrderList)
      // if (isDiffWarehouse) {
      //   this.$commonJs.alertTips({
      //     type: 'error',
      //     title: 'error',
      //     content: '仓库不能为两个不同仓库，请重新下单',
      //     stayTime: 5
      //   })
      //   return false
      // }
      // 检查必须选中计量方式
      const isHaveUnselectedCalculateMethod = !selected.every(function (currVal, currIndex, arr) {
        if (!currVal.settlementType) {
          return false
        }
        return true
      })
      if (isHaveUnselectedCalculateMethod) {
        this.$commonJs.alertTips({
          type: 'error',
          title: 'error',
          content: '选中项计量方式未选择',
          stayTime: 5
        })
        return false
      }
      // 计量方式为磅计的商品
      const poundItems = selected.filter(function (currVal, currIndex, arr) {
        return currVal.settlementType === '2'
      })
      // 磅计订单小于300公斤弹出确认框
      const isLessThen300 = !poundItems.every(function (currVal, currIndex, arr) {
        // console.log(currVal, '重量');
        // 300公斤为0.3吨
        const totalWeight = currVal.shopGoodVO.weight * currVal.amount
        console.log(totalWeight)
        return totalWeight >= 0.3
      })
      if (isLessThen300) {
        this.showModel2 = true
        return false
      }
      this.orderType = type
      let data = {
        cartIds: [],
        deliveryId: 0,
        detailList: [
          {
            accountId: 1,
            accountTotalAmt: parseFloat(this.allTotalPrice.toFixed(2)),
            accountTotalScore: 0,
            appOrderGoodParamList: [
            ],
            couponId: (this.couponList[this.selectCouponIndex] && this.couponList[this.selectCouponIndex].couponId) || 0,
            deliveryMethod: '1',
            hasFullAmountGood: '0',
            liveMessage: this.lisuanLeaveMessage,
            noExpressFeeMap: {}
          }
        ]
      }
      let goodList = this.baigangOrderList
      for (let i = 0; i < goodList.length; i++) {
        if (goodList[i].shopCarId && goodList[i].checked && goodList[i].status === '1') {
          data.cartIds.push(goodList[i].shopCarId)
        }
        let goodData = {
          goodId: goodList[i].goodId || goodList[i].id,
          number: goodList[i].amount,
          settlementType: goodList[i].settlementType,
          skuId: goodList[i].skuId
        }
        if (goodList[i].checked && goodList[i].status === '1') {
          data.detailList[0].appOrderGoodParamList.push(goodData)
        }
      }
      this.orderPostData = data
      if (!this.orderPostData.detailList[0].voucherUrl) {
        this.orderPostData.detailList[0].voucherUrl = ''
      }
      let memberInfo = await this.$axiox.asyncGet('/baigang/sys/user/getCurrUserInfo')
      window.localStorage.setItem('MemberInfo', JSON.stringify(memberInfo))
      // if (memberInfo.account.balance >= data.detailList[0].accountTotalAmt) {
      this.$axiox.post('/baigang/shop/app/order/shopAddOrder/' + (type === 'lisuan' ? 1 : 2), data).then(p => {
        this.totalMoney = data.detailList[0].accountTotalAmt
        if (p.code === 0) {
          console.log('p', p)
          debugger
          this.orderNum = p.data
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功:',
            content: '下单成功！',
            stayTime: 5
          })
          // console.log('p', p)
          // debugger
          location.href = pubilshSet.userCenterHostUrl + 'orderDetails/' + p.data
          setTimeout(() => {
            location.reload()
          }, 500)
          // window.open(pubilshSet.userCenterHostUrl + 'orderDetails/' + p.data)
        }
      })
      // } else {
      //   this.showModel1 = true
      // }
    },
    showDetailFun (item) {
      this.showDetail2 = true
      this.$nextTick(p => {
        // eslint-disable-next-line no-undef
        map = new AMap.Map('container', {
          resizeEnable: true,
          center: [parseFloat(item.longitude), parseFloat(item.latitude)],
          zoom: 13
        })
        clearMarker()
        addMarker(parseFloat(item.longitude), parseFloat(item.latitude), item.name)
      })
    },
    async changeAmount (type, item) {
      if (type) {
        if (type === 'add') {
          item.amount++
        }
        if (type === 'sub') {
          if (item.amount > 1) {
            item.amount--
          } else {
            item.amount = 1
          }
        }
        // 将修改上传到服务器
        let data = await this.$axiox.asyncGet(`/baigang/buyer/center/editCartGoodNum/${item.id}?num=${item.amount}`)
        console.log(data)
        if (data === true) {
          this.$commonJs.alertTips({
            type: 'success',
            title: '操作成功！',
            content: '操作成功！',
            stayTime: 5
          })
        } else {
          if (type === 'add') {
            item.amount--
          }
          if (type === 'sub') {
            item.amount++
          }
        }
        // 将修改缓存到LocalStorage
        window.localStorage.setItem('baigangOrderList', JSON.stringify(this.baigangOrderList))
      }
    },
    async addToShopCar ({ amount, goodId, skuId }) {
      let data = await this.$axiox.post('/baigang/buyer/center/addGoodToCart', {
        amount: amount,
        goodId: goodId,
        skuId: skuId
      })
      return data
    },
    // 商品选择发生change如果长度为0,清空优惠券
    shopIsZeroClear ($event) {
      const shopChecked = $event.map(item => item.checked).filter(item => item === true)
      // console.log(shopChecked, '123')
      if (shopChecked.length === 0) {
        // 没有商品选中后,取消优惠券
        this.selectCouponIndex = -1
      }
    }
  },
  computed: {
    lijitotalCount () {
      let total = {
        number: 0,
        price: 0,
        lisuanPrice: 0,
        lisuanWeight: 0,
        weight: 0,
        diaochefei: 0,
        lisuanDiaochefei: 0,
        bangjidiaochefei: 0,
        lisuanAllTotalPrice: 0
      }
      for (let i = 0; i < this.baigangOrderList.length; i++) {
        console.log(this.baigangOrderList[i].chooseMethod)
        if (this.baigangOrderList[i].settlementType === '1' && this.baigangOrderList[i].checked && this.baigangOrderList[i].status === '1') {
          total.number++
          total.lisuanWeight += (this.baigangOrderList[i].shopGoodVO.lisuanWeight || 0) * this.baigangOrderList[i].amount
          total.weight += (this.baigangOrderList[i].shopGoodVO.weight || 0) * this.baigangOrderList[i].amount
          total.price += (this.baigangOrderList[i].shopGoodVO.price || 0) * this.baigangOrderList[i].amount * this.baigangOrderList[i].shopGoodVO.weight
          total.lisuanPrice += (this.baigangOrderList[i].shopGoodVO.lisuanPrice || 0) * this.baigangOrderList[i].amount * this.baigangOrderList[i].shopGoodVO.lisuanWeight
          total.diaochefei += parseFloat((this.baigangOrderList[i].shopGoodVO.hoistingFee || 0) * this.baigangOrderList[i].shopGoodVO.weight * this.baigangOrderList[i].amount)
          total.lisuanDiaochefei += parseFloat((this.baigangOrderList[i].shopGoodVO.hoistingFee || 0) * this.baigangOrderList[i].shopGoodVO.lisuanWeight * this.baigangOrderList[i].amount)
          total.bangjidiaochefei += parseFloat((this.baigangOrderList[i].diaochefei || 0) * this.baigangOrderList[i].shopGoodVO.weight * this.baigangOrderList[i].amount)
        }
      }
      total.lisuanAllTotalPrice = total.lisuanDiaochefei + total.lisuanPrice
      // if (this.couponList[this.selectCouponIndex]) {
      //   let couponItem = this.couponList[this.selectCouponIndex]
      //   if (parseInt(couponItem.type) === 2) {
      //     console.log('触发了几次1')
      //     let temp = total.lisuanAllTotalPrice - couponItem.couponValue
      //     // if (temp <= 0) {
      //     //   this.$commonJs.alertTips({
      //     //     type: 'error',
      //     //     title: '错误',
      //     //     content: '优惠券满减金额大于选中商品金额!',
      //     //     stayTime: 5
      //     //   })
      //     //   return
      //     // }
      //     total.lisuanAllTotalPrice = temp
      //   } else {
      //     console.log('触发了几次2')
      //     total.lisuanAllTotalPrice = total.lisuanAllTotalPrice * (couponItem.couponValue / 10)
      //   }
      // }
      // console.log('bangjiAllTotalPrice', total.lisuanAllTotalPrice)
      return total
    },
    bangjitotalCount () {
      let total = {
        number: 0,
        price: 0,
        lisuanPrice: 0,
        lisuanWeight: 0,
        weight: 0,
        diaochefei: 0,
        bangjidiaochefei: 0,
        bangjiAllTotalPrice: 0,
        lisuanDiaochefei: 0
      }
      for (let i = 0; i < this.baigangOrderList.length; i++) {
        if (this.baigangOrderList[i].settlementType === '2' && this.baigangOrderList[i].checked) {
          total.number++
          total.lisuanWeight += (this.baigangOrderList[i].shopGoodVO.lisuanWeight || 0) * this.baigangOrderList[i].amount
          total.weight += (this.baigangOrderList[i].shopGoodVO.weight || 0) * this.baigangOrderList[i].amount
          total.price += (this.baigangOrderList[i].shopGoodVO.price || 0) * this.baigangOrderList[i].amount * this.baigangOrderList[i].shopGoodVO.weight
          total.lisuanPrice += (this.baigangOrderList[i].shopGoodVO.lisuanPrice || 0) * this.baigangOrderList[i].amount * this.baigangOrderList[i].shopGoodVO.lisuanWeight
          total.diaochefei += parseFloat((this.baigangOrderList[i].shopGoodVO.hoistingFee || 0) * this.baigangOrderList[i].shopGoodVO.weight * this.baigangOrderList[i].amount)
          total.lisuanDiaochefei += parseFloat((this.baigangOrderList[i].shopGoodVO.hoistingFee || 0) * this.baigangOrderList[i].shopGoodVO.lisuanWeight * this.baigangOrderList[i].amount)
          total.bangjidiaochefei += parseFloat((this.baigangOrderList[i].shopGoodVO.hoistingFee || 0) * this.baigangOrderList[i].shopGoodVO.weight * this.baigangOrderList[i].amount)
        }
      }

      total.bangjiAllTotalPrice = total.bangjidiaochefei + total.price
      // if (this.couponList[this.selectCouponIndex]) {
      //   let couponItem = this.couponList[this.selectCouponIndex]
      //   if (parseInt(couponItem.type) === 2) {
      //     console.log('触发了几次11')
      //     let temp = total.bangjiAllTotalPrice - couponItem.couponValue
      //     // if (temp <= 0) {
      //     //   this.$commonJs.alertTips({
      //     //     type: 'error',
      //     //     title: '错误',
      //     //     content: '优惠券满减金额大于选中商品金额！',
      //     //     stayTime: 5
      //     //   })
      //     //   return
      //     // }
      //     total.bangjiAllTotalPrice = temp
      //   } else {
      //     console.log('触发了几次22')
      //     total.bangjiAllTotalPrice = total.bangjiAllTotalPrice * (this.couponList[this.selectCouponIndex].couponValue / 10)
      //   }
      // }
      // console.log('bangjiAllTotalPrice', total.bangjiAllTotalPrice)
      return total
    },
    allTotalPrice () {
      let total = null
      total = this.lijitotalCount.lisuanAllTotalPrice + this.bangjitotalCount.bangjiAllTotalPrice
      if (this.couponList[this.selectCouponIndex]) {
        let couponItem = this.couponList[this.selectCouponIndex]
        if (parseInt(couponItem.type) === 2) {
          total = total - couponItem.couponValue
        } else {
          total = total * (this.couponList[this.selectCouponIndex].couponValue / 10)
        }
      }
      return total
    }
  },
  components: { Index }
}
function clearMarker () {
  if (marker) {
    marker.setMap(null)
    marker = null
  }
}
function addMarker (x, y, name) {
  // eslint-disable-next-line no-undef
  marker = new AMap.Marker({
    icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
    position: [x, y],
    // eslint-disable-next-line no-undef
    offset: new AMap.Pixel(-13, -30)
  })
  var markerContent = document.createElement('div')

  // 点标记中的图标
  var markerImg = document.createElement('img')
  markerImg.className = 'markerlnglat'
  markerImg.src = '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png'
  markerContent.appendChild(markerImg)

  // 点标记中的文本
  var markerSpan = document.createElement('span')
  markerSpan.className = 'marker'
  markerSpan.innerHTML = name
  markerContent.appendChild(markerSpan)
  marker.setContent(markerContent)
  marker.setMap(map)
}
</script>

<style scoped>
.seldOut {
  opacity: 0.5;
  pointer-events: none;
}
.reduce-nerver {
  background: #ccc;
  cursor: not-allowed;
  pointer-events: none;
}
.never {
  pointer-events: none;
  position: relative;
}
.never::before {
  content: '磅计商品不能使用优惠券支付';
  color: red;
  top: 3px;
  left: 20px;
  position: absolute;
  z-index: 2;
}
.never::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6);
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/page/mySteelMall/myOrderDelivery.vue